export type ActiveEvent = { uuid: string; tab: string };

const tabs = new Set(['general', 'landing', 'gifts', 'guests']);
export const isEventUuid = (value: unknown): value is string => typeof value === 'string'
  && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value);
const key = (userUuid: string) => `jubiel.active-event.${userUuid}`;

/** Tab-local navigation state, scoped to the signed-in account (JUB-156). */
export function rememberActiveEvent(userUuid: string | undefined, uuid: string, tab: string): void {
  if (!userUuid || !isEventUuid(uuid)) return;
  try {
    sessionStorage.setItem(key(userUuid), JSON.stringify({ uuid, tab: tabs.has(tab) ? tab : 'general' }));
  } catch { /* Navigation still works when browser storage is unavailable. */ }
}

export function readActiveEvent(userUuid: string): ActiveEvent | null {
  try {
    const value = JSON.parse(sessionStorage.getItem(key(userUuid)) || 'null');
    return value && isEventUuid(value.uuid)
      ? { uuid: value.uuid, tab: tabs.has(value.tab) ? value.tab : 'general' }
      : null;
  } catch { return null; }
}

export function forgetActiveEvent(userUuid: string, uuid: string): void {
  if (readActiveEvent(userUuid)?.uuid !== uuid) return;
  try { sessionStorage.removeItem(key(userUuid)); } catch { /* Storage may be unavailable. */ }
}
